import AnnotationsHandler from '..';
import Constants from '../../constants';
import { C11nEnv } from '../../interpreter/c11n-env';

AnnotationsHandler.registerHandler('@CASE', (value: string, c11nEnv: C11nEnv) => {
  if (value === Constants.ID) {
    return c11nEnv.getCaseInfo().getKey();
  }
  return value;
});
